import React, { useEffect,useCallback, useRef,useMemo, useState } from 'react';
// import AgGrid from "./AgGrid"
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { columnwithDefs } from "./columnDefs_vehicles";
import Constants from "./Masters_constants";
import redirectURL from "../redirectURL";
import EditItem from './EditItem'
import Select from 'react-select';
import DeletePartner from './deleteItem'
import SweetAlert from 'react-bootstrap-sweetalert';
import { getHyphenDDMMMYYYYHHMM } from '../common/utils';
import { format } from 'date-fns';

function Masters() {
    var [rowData, setRowData] = useState([])
    var [columnDefs, setColumnDefs] = useState([
        {
            headerName: "Action",
            field: "_id",
            resizable: true,
            width: 80,
            filter: false,
            cellRenderer: EditItem,
            pinned: "left"
            // editable: false
        },
        {
            headerName: "",
            field: "_id",
            width: 50,
            cellRenderer: DeletePartner,
            pinned: "left"
        },
        {
            headerName: "Invoice Series",
            field: "invoice_series",
            width: 240,
            filter: true,
    
        },
    
        {
            headerName: "Invoice Source",
            field: "invoice_source",
            width: 240,
            filter: true,
    
        },
    
        {
            headerName: "Invoice Category",
            field: "invoice_category",
            width: 240,
            filter: true,
    
        }
        // {
        //     headerName: "Created Date",
        //     field: "created_date",
        //     width: 220,
        //     type: "datetime",
        //     filter: true,
        //     valueGetter: (params) => {
        //         if (!params.value) return '';
        //         const date = new Date(params.value);
        //         return format(date, 'dd-MM-yyyy');
        //     },
        // }
    
    ])
    // var [showloaderbg, setshowloaderbg] = useState("show-m");
    const gridApiConsignments = useRef();
    const columnApiConsignments = useRef(null);
    var [showloader, setshowloader] = useState("show-m");
    var [showAddSlider, setshowAddSlider] = useState("");
    var [overlay, setoverlay] = useState("show-n");
    var [rowid ,setRowId] = useState();
    var [sliderText, setSliderText] = useState("");
    const [isEditMode, setIsEditMode] = useState(false);
    var [invoice_series, setinvoiceseries] = useState("");
    var [invoice_source, setinvoicesource] = useState("");
    var [invoice_category, setinvoicecategory] = useState("");
    const [invoicesourceOptions, setInvoiceSourceOptions] = useState([])
    const [invoicecategoryOptions, setInvoiceCategoryOptions] = useState([])
    var [is_active, setstatus] = useState("");
    // var modules = useState(AllModules);
    var paginationPageSize = useState(50);

    var [show, setShow] = useState(false);
    var [basicType, setBasicType] = useState("");
    var [basicTitle, setBasicTitle] = useState("");

    const defaultColDef = useMemo(() => {
        return {
            //flex: 1,
            resizable:true,
            sortable: true,
            filter: true,
            editable:false

        };
    }, []);

    const onGridReadyConsignments = useCallback((params) => {
        gridApiConsignments.current = params.api
        columnApiConsignments.current = params.columnApi
    }, []);

    const getCurrentFormattedDate = () => {
        const date = new Date();
        return format(date, 'dd-MM-yyyy');
    };

    const getCurrentISODate = () => {
        const date = new Date();
        return date.toISOString();
    };

    useEffect(() => {
        setTimeout(() => {
            // setshowloaderbg("show-n")
            setshowloader("show-n")
        }, 2000)
        loadData();

        // 
    }, [])

    var loadData = async () => {
        var parameters = {}
        await redirectURL.post('/invoicelist', parameters)
            .then(response => {
                if (response.data.status == "success") {
                    setRowData(response.data.records);
                    const distinctInvoiceSource = [...new Set(response.data.records.map(item => item.invoice_source))];
                    setInvoiceSourceOptions(distinctInvoiceSource.map(e=>{ return {label:e, value:e}}))
                    const distinctInvoiceCategory = [...new Set(response.data.records.map(item => item.invoice_category))];
                    setInvoiceCategoryOptions(distinctInvoiceCategory.map(e=>{ return {label:e, value:e}}))
                    console.log(distinctInvoiceSource,"setInvoiceSourceOptions");
                    console.log(distinctInvoiceCategory,"setInvoiceCategoryOptions");
                    
                    
                }
                setshowloader("show-n");

            })
            .catch(error => console.error('Error fetching data:', error));
    }

    var onClickDeleteItem = async (rownode) => {
        console.log("Rownode Update", rownode);
        var params = {
            invoice_series: rownode.data.invoice_series
        }
    
        try {
            const resp = await redirectURL.post('/deleteinvoiceDetails', params);
            console.log(resp,"resp",resp.data.status,"success");
            
            if (resp.data.status === "success") {
                setoverlay("show-n");
                setshowloader("show-n");
                setShow(true);
                setBasicTitle("Invoice Deleted Successfully");
                setBasicType("success");
                loadData();
            }
        } catch (error) {
            console.error("Error deleting invoice details:", error);
        }
    };
    

    var showAddBlock = async (rownode) => {
        setshowAddSlider("slider-translate-30p");
        setoverlay("show-m")
        setSliderText("Add Invoice");
        setinvoicesource("");
        setinvoicecategory("");
        setinvoiceseries("");
        setIsEditMode(false);

    }

    var onClickEditBlock  = async (rownode) =>{
        console.log("rownode ", rownode)

        setshowAddSlider("slider-translate-30p");
        setoverlay("show-m");
        setSliderText("Edit Invoice");
        setRowId(rownode.data._id);
        setinvoicesource({label:rownode.data.invoice_source,value:rownode.data.invoice_source});
        setinvoicecategory({label:rownode.data.invoice_category,value:rownode.data.invoice_category});
        setinvoiceseries(rownode.data.invoice_series);
        setIsEditMode(true);
    }
    

    var hideAll = () => {
        setoverlay("show-n");
        setshowAddSlider("");
    }


    var saveMasterForm = async (e) => {
        e.preventDefault();
        let user_email = localStorage.getItem('email');
        // setshowloaderbg("show-m");
        const createdDate = getCurrentISODate();
        setshowloader("show-m")
        if(isEditMode) {
            var params = {
                invoice_source: invoice_source.value,
                invoice_category: invoice_category.value,
                invoice_series: invoice_series,
                // is_active: is_active,
                modified_date: createdDate,
            }
        }
        else {
            var params = {
                invoice_source: invoice_source.value,
                invoice_category: invoice_category.value,
                invoice_series: invoice_series,
                created_date: createdDate,
            }
        }
        
        console.log(params, "params");
        console.log(isEditMode, "edit mode");
        if (isEditMode) {
            await redirectURL.post('/updateinvoicedata', params).then((resp) => {
                console.log(resp, "edit response");
                if (resp.data.status === "success") {
                    setoverlay("show-n");
                    setshowAddSlider("");
                    setshowloader("show-n");
                    setinvoicesource("");
                    setinvoicecategory("");
                    setinvoiceseries("");
                    setstatus("");
                    setIsEditMode(false);
                    setShow(true);
                    setBasicTitle("Updated Invoice Data");
                    setBasicType("success");
                    loadData();
                }
            });
        } else {
            await redirectURL.post('/addinvoice', params).then((resp) => {
                if (resp.data.status === "success") {
                    setoverlay("show-n");
                    setshowAddSlider("");
                    setinvoicesource("");
                    setinvoicecategory("");
                    setinvoiceseries("");
                    setstatus("");
                    setIsEditMode(false);
                    setShow(true);
                    setBasicTitle("Added Invoice Data");
                    setBasicType("success");
                    loadData();
                } else if (resp.data.status === "failure") {
                    setoverlay("show-n");
                    setshowloader("show-n");
                    setIsEditMode(false);
                    setshowAddSlider("");
                    setinvoicesource("");
                    setinvoicecategory("");
                    setinvoiceseries("");
                    setstatus("");
                    setShow(true);
                    setBasicTitle(resp.data.message);
                    setBasicType("danger");
                }
            }).catch(err => {
            });
        }
    };

    var handleInvoiceSeries = (e) => {
        var inputValue = e.target.value;
        if (inputValue != "") {
            var isValid = /^[A-Z /]*$/;
            if (isValid.test(inputValue)) {
                if (inputValue.length <= 100) {
                    setinvoiceseries(inputValue)
                }
            }
        }
        else {
            setinvoiceseries("");
        }
    };


    var handleInvoiceSource = (selectedOption) => {
        console.log(selectedOption,"selectedOption");
        setinvoicesource(selectedOption);
    }    

    var handleInvoiceCategory = (selectedOption) => {
        console.log(selectedOption,"selectedOption");
        setinvoicecategory(selectedOption);
    }

    return (
        <div>
            <div className="container-fluid">
                <SweetAlert
                    show={show}
                    type={basicType}
                    title={basicTitle}
                    onConfirm={() => {
                        setShow(false)
                    }}>
                </SweetAlert>


            </div>
            <div className="container-fluid mt-20p">
                <div className="row">


                    <div className="col-xl-12 col-md-12 xl-60">
                        <div className="card">
                            <div className="col-lg-12 d-flex justify-content-between align-items-center" style={{ marginTop: "20px" }}>
                                <h4 className="screen-name">Invoice Master</h4>
                                {
                                    Constants.VEHICLES.BTN_ADD === 1 ? (
                                        <button className="btn btn-warning pull-right" onClick={showAddBlock}><i className="icon-plus"></i> Add Invoice</button>
                                    ) : ""
                                }
                            </div>
                            <div className="card-body">
                            <div className={"ag-theme-balham mt-8"} style={{ height: '500px', width: '100%', paddingTop: "1rem" }}>
                                <AgGridReact
                                    columnDefs={columnDefs}
                                    rowData={rowData}
                                    defaultColDef={defaultColDef}
                                    pagination={true}
                                    paginationPageSize={50}
                                    onGridReady={onGridReadyConsignments}
                                    enableRangeSelection={true}
                                    enableCellContextMenu={true}
                                    masterDetail={true}
                                    context={{onClickEditBlock,onClickDeleteItem}}
                                    // detailCellRendererParams={detailCellRendererParams}
                                    // frameworkComponents ={{AddDealer:AddDealerConsignments}}
                                    sideBar={{
                                        toolPanels: [
                                            {
                                                id: "columns",
                                                labelDefault: "Columns",
                                                labelKey: "columns",
                                                iconKey: "columns",
                                                toolPanel: "agColumnsToolPanel",
                                                toolPanelParams: {
                                                    suppressPivotMode: true,
                                                    suppressRowGroups: true,
                                                    suppressValues: true,
                                                }
                                            },
                                            {
                                                id: "filters",
                                                labelDefault: "Filters",
                                                labelKey: "filters",
                                                iconKey: "filter",
                                                toolPanel: "agFiltersToolPanel"
                                            }
                                        ]
                                    }}
                                    statusBar={{
                                        statusPanels: [
                                            {
                                                statusPanel: "agTotalAndFilteredRowCountComponent",
                                                align: "left"
                                            },
                                            {
                                                statusPanel: "agTotalRowCountComponent",
                                                align: "center"
                                            },
                                            { statusPanel: "agFilteredRowCountComponent" },
                                            { statusPanel: "agSelectedRowCountComponent" },
                                            { statusPanel: "agAggregationComponent" }
                                        ]
                                    }}
                                    />
                                {/* <AgGrid
                                    rowData={rowData}
                                    //  columnDefs={columnwithDefs}
                                    columnDefs={columnDefs}
                                    currentPage={window.location.pathname}
                                    others={""}
                                    // onClickEditBlock={onClickShowEditItem}
                                    saveoptions={"N"}
                                    context={{onClickEditBlock}}
                                /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className={"overlay-part " + (overlay)} ></div> */}

            <div className={"slide-r " + showAddSlider}>
                <div className="slide-r-title">
                    <h4 className="">{sliderText}
                        <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={hideAll} >X</span>

                    </h4>

                </div>
                <div className="slide-r-body">

                    <form className="" style={{ padding: "20px" }} onSubmit={saveMasterForm}>
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Invoice Series<span style={{ color: 'red' }}>*</span></label>
                            <input type="text" name="invoice_series"
                            disabled={isEditMode}
                            value={invoice_series} style={{
                                width: "100%",
                                padding: "10px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                backgroundColor: "#f9f9f9",
                            }} onChange={handleInvoiceSeries} required />
                        </div>

                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Invoice Source<span style={{ color: 'red' }}>*</span></label>
                            <Select
                            closeMenuOnSelect={true}
                             value={invoice_source}
                            // multi={true}
                            // className={"border-radius-0"} 
                            onChange={handleInvoiceSource}
                            options={invoicesourceOptions}
                            // style={{ borderRadius: "0px" }}
                            >
                        </Select>
                        </div>

                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Invoice Category<span style={{ color: 'red' }}>*</span></label>
                            <Select
                            closeMenuOnSelect={true}
                             value={invoice_category}
                            // multi={true}
                            // className={"border-radius-0"} 
                            onChange={handleInvoiceCategory}
                            options={invoicecategoryOptions}
                            // style={{ borderRadius: "0px" }}
                            >
                        </Select>
                        </div>

                        {isEditMode ? 
                        <>
                        <div className="form-group" style={{ textAlign: "center" }}>
                            <button type="submit" className="btn btn-success"
                                style={{
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "4px",
                                    backgroundColor: "#28a745",
                                    color: "white",
                                }}
                            >Update Invoice</button>
                        </div>
                        </>
                        :
                        <>
                        <div className="form-group" style={{ textAlign: "center" }}>
                            <button type="submit" className="btn btn-success"
                                style={{
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "4px",
                                    backgroundColor: "#28a745",
                                    color: "white",
                                }}
                            >Add Invoice</button>
                        </div>
                        </>
                        }
                        {/* <div className="form-group" style={{ textAlign: "center" }}>
                            <button type="submit" className="btn btn-success"
                                style={{
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "4px",
                                    backgroundColor: "#28a745",
                                    color: "white",
                                }}
                            >Add Invoice</button>
                        </div> */}

                    </form>
                </div>

            </div>

            <div className={"dataLoadpage " +(showloader)}>
                </div>
                <div className={"dataLoadpageimg " +(showloader)}>
                    <div class="loader-box"><div class="loader-box"><div class="rotate dashed colored"></div></div></div>
                </div>
                <div className={"overlay-part "+(overlay)} onClick={hideAll}></div>


        </div>
    );
}

export default Masters;

